import { THEME_COLORS as THEME_COLORS_MAIN } from "../../theme/colors";
declare module "@mui/material/styles" {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface Palette {
        green: Record<number, string>;
        gray: Record<number, string>;
        pear: Record<number, string>;
        yellow: Record<number, string>;
        orange: Record<number, string>;
        blush: Record<number, string>;
        red: Record<number, string>;
        lilac: Record<number, string>;
        blue: Record<number, string>;
        sky: Record<number, string>;
        teal: Record<number, string>;
        blackAlpha: Record<number, string>;
        whiteAlpha: Record<number, string>;
    }

    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface PaletteOptions {
        green?: Record<number, string>;
        gray?: Record<number, string>;
        pear?: Record<number, string>;
        yellow?: Record<number, string>;
        orange?: Record<number, string>;
        blush?: Record<number, string>;
        red?: Record<number, string>;
        lilac?: Record<number, string>;
        blue?: Record<number, string>;
        sky?: Record<number, string>;
        teal?: Record<number, string>;
        blackAlpha?: Record<number, string>;
        whiteAlpha?: Record<number, string>;
    }
}

export const THEME_COLORS = {
    ...THEME_COLORS_MAIN,
    blackAlpha: {
        50: "rgba(0, 0, 0, 0.04)",
        100: "rgba(0, 0, 0, 0.06)",
        200: "rgba(0, 0, 0, 0.08)",
        300: "rgba(0, 0, 0, 0.16)",
        400: "rgba(0, 0, 0, 0.24)",
        500: "rgba(0, 0, 0, 0.36)",
        600: "rgba(0, 0, 0, 0.48)",
        700: "rgba(0, 0, 0, 0.64)",
        800: "rgba(0, 0, 0, 0.80)",
        900: "rgba(0, 0, 0, 0.92)",
    },
    whiteAlpha: {
        50: "rgba(255, 255, 255, 0.04)",
        100: "rgba(255, 255, 255, 0.06)",
        200: "rgba(255, 255, 255, 0.08)",
        300: "rgba(255, 255, 255, 0.16)",
        400: "rgba(255, 255, 255, 0.24)",
        500: "rgba(255, 255, 255, 0.36)",
        600: "rgba(255, 255, 255, 0.48)",
        700: "rgba(255, 255, 255, 0.64)",
        800: "rgba(255, 255, 255, 0.80)",
        900: "rgba(255, 255, 255, 0.92)",
    },
};
